import { Collections, Delete } from "@mui/icons-material";
import TextInput from "../TextInput";
import { IconButton } from "@mui/material";
import { ChangeEvent, useRef, useState } from "react";
import ImageModal from "./components/ImageModal";
import { useToast } from "../../hooks/useToast";

interface Props {
  id: string;
  value: any;
  handleFormItem: any;
}

export default function ImageUpload(props: Props) {
  const { id, value, handleFormItem } = props;

  const [item, setItem] = useState<any>();
  const { toast } = useToast();

  const inputRef = useRef<HTMLInputElement>(null);

  const handleSelectFile = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) {
      return;
    }
    if (!file.type.startsWith("image/")) {
      toast({
        message: "Selecione um arquivo de imagem.",
        type: "error",
      });
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      toast({
        message: "A imagem deve ter no máximo 2 MB.",
        type: "error",
      });
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      handleFormItem(
        [
          ...(value ?? []),
          {
            url: String(reader.result),
            name: file.name,
            title: file.name.replace(/\.[^.]+$/, ""),
          },
        ],
        id
      );
    };
    reader.readAsDataURL(file);
  };

  const handleDeleteImage = (nameToRemove: string) => {
    const updatedMedia = value?.filter(
      (item: any) => item.name !== nameToRemove
    );

    handleFormItem(updatedMedia, id);
  };

  return (
    <>
      {item && (
        <ImageModal
          text={item.title}
          imgSrc={item.url}
          onClose={() => setItem(undefined)}
        />
      )}
      <div className="mt-2">
        {!!value &&
          value?.map((item: any, index: number) => (
            <div className="flex flex-col gap-3" key={item?.url || id}>
              <div className="flex justify-between items-center">
                <TextInput
                  placeholder="Nome da imagem…"
                  value={item?.title}
                  variant="outlined"
                  onChange={(e) => {
                    value[index].title = e.target.value;
                    handleFormItem([...value], id);
                  }}
                />
                <IconButton
                  aria-label="Remover imagem"
                  onClick={() => handleDeleteImage(item.name)}
                >
                  <Delete className="text-red" />
                </IconButton>
              </div>
              <button
                type="button"
                className="relative mb-3 h-[150px] w-[150px] cursor-pointer overflow-hidden rounded-lg"
                onClick={() => setItem(item)}
              >
                <img
                  src={item.url}
                  alt={item.title || "Foto da praça"}
                  width={150}
                  height={150}
                  className="h-full w-full object-cover"
                />
                <div className="absolute bottom-0 w-full bg-black/60 py-2 text-center text-white">
                  <span className="text-sm">Clique para visualizar</span>
                </div>
              </button>
            </div>
          ))}

        <button
          type="button"
          className="mt-2 flex h-[140px] w-full flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-primary/30 bg-white transition-colors hover:bg-primaryLight"
          onClick={() => inputRef?.current?.click()}
        >
          <input
            className="hidden"
            type="file"
            accept="image/*"
            ref={inputRef}
            onChange={handleSelectFile}
          />
          <Collections fontSize="large" className="text-primary" aria-hidden="true" />
          <p className="font-semibold text-primary">Adicionar foto</p>
          <p className="text-xs text-muted">JPEG ou PNG, até 2 MB</p>
        </button>
      </div>
    </>
  );
}
